import { render, staticRenderFns } from "./resourceCard.vue?vue&type=template&id=16c73205&scoped=true&"
import script from "./resourceCard.vue?vue&type=script&lang=js&"
export * from "./resourceCard.vue?vue&type=script&lang=js&"
import style0 from "./resourceCard.vue?vue&type=style&index=0&id=16c73205&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c73205",
  null
  
)

export default component.exports